import getInitialData from './utils/getInitialData';

const initialData = getInitialData();

const tableDefaults  = {
    header: {
        fill: false,
        dark: true,
        border: true,
        topBottomBorder: true,
        sticky: false,
        stickyOffset: 52
    },
    body: {
        fill: true,
        border: true,
        raised: false,
        verticalCellBorder: true
    }    

}

export default {
    appName: initialData.settings.AppName,
    hostName: initialData.settings.BasePath,
    isDebug: initialData.settings.IsDebug,
    tableDefaults,
}